import County from './County';

export default class {
    id: number;
    easternTownshipTypeId: number;
    name: string;
    number: string;
    projectId: number;
    counties: Array<County>;
    mapNumbers: Array<number>;
    mapCount: number;
}



// WEBPACK FOOTER //
// ./src/models/EasternTownship.ts